// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BottomBarItemBlank-base__UxOO0{position:relative;display:block;width:var(--size-full);padding:var(--size-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "BottomBarItemBlank-base__UxOO0"
};
export default ___CSS_LOADER_EXPORT___;
